var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.Imfor.type === 1)?_c('device-view-item1',{attrs:{"Imfor":_vm.Imfor,"mqttClient":_vm.mqttClient}}):_vm._e(),(_vm.Imfor.type === 0)?_c('device-view-item',{attrs:{"Imfor":_vm.Imfor,"mqttClient":_vm.mqttClient}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }